import React from 'react';
import { Link } from 'react-router-dom';
import { Cookie, MapPin, MessageCircle, ShoppingBag, Clock, Snowflake, Building2 } from 'lucide-react';
import { useApp } from '../context/AppContext';

const WHATSAPP_URL = 'https://wa.me/message/GUPEJ7AY7SEBI1';
const WHATSAPP_LABEL = '077 242 61 65';

export default function Footer() {
  const { t } = useApp();
  const year = new Date().getFullYear();

  return (
    <footer className="mt-24 bg-[#2f3826] text-neutral-200">
      <div className="max-w-[1280px] mx-auto px-5 py-14 grid gap-10 md:grid-cols-3">
        {/* who we are */}
        <div>
          <div className="flex items-center gap-2.5 mb-4">
            <span className="flex items-center justify-center w-9 h-9 rounded-full bg-white/10">
              <Cookie size={20} className="text-[#d9b06a]" />
            </span>
            <span className="font-display text-[20px] text-white">Metio Frigo</span>
          </div>
          <p className="text-sm text-neutral-400 leading-relaxed max-w-xs">{t('fridges_sub')}</p>
          <p className="mt-4 flex items-center gap-2 text-sm text-neutral-300">
            <Snowflake size={15} className="text-[#d9b06a] shrink-0" /> {t('opening_always')}
          </p>
        </div>

        {/* the two ways to get a meal — the fridge, or a pre-order */}
        <div>
          <h4 className="font-display text-lg text-white mb-4">{t('how_title')}</h4>
          <ol className="space-y-4 text-sm">
            <li className="flex gap-3">
              <span className="shrink-0 w-6 h-6 rounded-full bg-white/10 text-[#d9b06a] text-xs font-bold flex items-center justify-center">1</span>
              <span>
                <span className="block text-white font-medium">{t('how_step1_t')}</span>
                <span className="block text-neutral-400 leading-relaxed mt-0.5">{t('how_step1_d')}</span>
              </span>
            </li>
            <li className="flex gap-3">
              <span className="shrink-0 w-6 h-6 rounded-full bg-white/10 text-[#d9b06a] text-xs font-bold flex items-center justify-center">2</span>
              <span>
                <span className="block text-white font-medium">{t('how_step2_t')}</span>
                <span className="block text-neutral-400 leading-relaxed mt-0.5">{t('how_step2_d')}</span>
                <Link to="/?tab=week2" className="inline-flex items-center gap-1.5 mt-2 text-[#d9b06a] hover:text-white transition-colors">
                  <ShoppingBag size={14} /> {t('order_next_week')}
                </Link>
              </span>
            </li>
          </ol>
        </div>

        {/* everything else, one click away */}
        <div>
          <h4 className="font-display text-lg text-white mb-4">{t('more_info')}</h4>
          <ul className="space-y-3 text-sm">
            <li>
              <a href={WHATSAPP_URL} target="_blank" rel="noreferrer" data-testid="footer-whatsapp-link"
                 className="flex items-center gap-2 text-neutral-300 hover:text-white transition-colors">
                <MessageCircle size={15} className="text-[#d9b06a] shrink-0" />
                {t('whatsapp_helpline')} · {WHATSAPP_LABEL}
              </a>
            </li>
            <li>
              <Link to="/emplacements" className="flex items-center gap-2 text-neutral-300 hover:text-white transition-colors">
                <MapPin size={15} className="text-[#d9b06a] shrink-0" /> {t('nav_fridges')}
              </Link>
            </li>
            <li className="flex items-center gap-2 text-neutral-300">
              <Clock size={15} className="text-[#d9b06a] shrink-0" /> {t('deadline')}
            </li>
            <li>
              <Link to="/entreprise" data-testid="footer-company-link" className="flex items-center gap-2 text-neutral-300 hover:text-white transition-colors">
                <Building2 size={15} className="text-[#d9b06a] shrink-0" /> {t('company_login')}
              </Link>
            </li>
          </ul>
          <p className="mt-5 text-xs text-neutral-500 leading-relaxed">{t('allergens_footer_note')}</p>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-[1280px] mx-auto px-5 py-5 text-xs text-neutral-500 flex flex-col sm:flex-row justify-between gap-2">
          <span>© {year} Metio Frigo · SCC Biopôle Sàrl</span>
          <span>Route de la Corniche 2, 1066 Épalinges</span>
        </div>
      </div>
    </footer>
  );
}
